<template>
	<v-container>
		<v-row>
			<v-col cols="12" lg="6" offset-lg="3">
				<v-carousel height="100%" cycle show-arrows-on-hover>
					<v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src"></v-carousel-item>
				</v-carousel>
			</v-col>

			<v-col>
				<h4>Schlafzimmer 2 (Obergeschoss).</h4>
				<ul>
					<li>Zwei Einzelbetten und Nachttisch</li>
					<li>Ein kleiner Sekretär mit Stuhl</li>
					<li>Die Betten werden vor Anreise frisch bezogen</li>
				</ul>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'Schlafen2OG',
	data: () => ({
		items: [
			{
				src: 'https://fewokruse.de/img/schlafen2og004.jpg',
			},
			{
				src: 'https://fewokruse.de/img/schlafen2og005.jpg',
			},
			{
				src: 'https://fewokruse.de/img/schlafen2og006.jpg',
			},
		],
	}),
};
</script>

<style></style>
